import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('Checkbox', slot);
}

// classes export 유지 (target으로 사용됨)
export const checkboxClasses = generateUtilityClasses('Checkbox', ['root']);

// theme 등록 완전 제거 (styleOverrides가 모두 컴포넌트로 이전되었음)
// export const checkboxThemes는 더 이상 필요 없음
